import React from 'react';
import styles from './font-picker-modal-header.scss';

export default function ModalHeader({ title, onClose }) {
  return (
    <header className={styles.header}>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.close} onClick={onClose} />
    </header>
  );
}

ModalHeader.propTypes = {
  onClose: React.PropTypes.func,
  title: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/font-picker-modal-header.jsx